import { render, staticRenderFns } from "./CardSection.vue?vue&type=template&id=b4c2f18a&scoped=true"
import script from "./CardSection.vue?vue&type=script&lang=js"
export * from "./CardSection.vue?vue&type=script&lang=js"
import style0 from "./CardSection.vue?vue&type=style&index=0&id=b4c2f18a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c2f18a",
  null
  
)

export default component.exports